export interface LocalizedField {
  en: string;
  zh: string;
  ja: string;
}

export interface Character {
  slug: string;
  name: string;
  nameZh: string;
  nameJa: string;
  fullName: string;
  fullNameZh: string;
  fullNameJa: string;
  gender: string;
  genderZh: string;
  genderJa: string;
  birthday: string;
  birthdayZh: string;
  birthdayJa: string;
  zodiac: string;
  zodiacZh: string;
  zodiacJa: string;
  bloodType: string;
  bloodTypeZh: string;
  bloodTypeJa: string;
  personality: string;
  personalityZh: string;
  personalityJa: string;
  interests: string;
  interestsZh: string;
  interestsJa: string;
  favoriteThings: string;
  favoriteThingsZh: string;
  favoriteThingsJa: string;
  bio: string;
  bioZh: string;
  bioJa: string;
  image: string;
  menuIcon: string;
  overviewImage: string;
}

export const characters: Character[] = [
  {
    slug: "liam-lion",
    name: "Liam",
    nameZh: "力力獅",
    nameJa: "リアム",
    fullName: "Liam the Loving Lion",
    fullNameZh: "力力獅 Liam",
    fullNameJa: "やさしいライオン リアム",
    gender: "Male",
    genderZh: "男生",
    genderJa: "男の子",
    birthday: "August 8th",
    birthdayZh: "8 月 8 日",
    birthdayJa: "8月8日",
    zodiac: "Leo",
    zodiacZh: "獅子座",
    zodiacJa: "しし座",
    bloodType: "Type O",
    bloodTypeZh: "O 型",
    bloodTypeJa: "O型",
    personality: "Brave, full of self-confidence, but sometimes feels timid and needs to learn to overcome inner fears.",
    personalityZh: "勇敢、充滿自信,但有時也會害怕,正在學習克服內心的恐懼。",
    personalityJa: "勇敢で自信たっぷり。でも時々こわくなって、心の中の不安をのりこえる練習をしているよ。",
    interests: "Exploring hidden paths, playing pretend, and helping his friends feel brave and strong.",
    interestsZh: "探索神秘小徑、玩角色扮演,幫朋友變得勇敢又有力量。",
    interestsJa: "ひみつの小道をたんけんしたり、ごっこあそびをしたり、ともだちを元気づけることが大すき。",
    favoriteThings: "Sunny weather, the taste of honey, eating all kinds of fruits, especially apples, and running on the grass.",
    favoriteThingsZh: "陽光、蜂蜜的味道、各種水果(特別是蘋果),還有在草地上奔跑。",
    favoriteThingsJa: "晴れた日、はちみつの味、いろんなくだもの(とくにりんご)、草の上を走ること。",
    bio: "Liam is the kind and brave little prince of Queebi Land. He loves going on adventures and leading his friends to fun new places. Sometimes Liam feels scared, just like everyone does. But he takes a deep breath, believes in himself, and keeps going.",
    bioZh: "力力獅是 酷比島裡善良又勇敢的小王子。他喜歡冒險,帶著朋友們去探索新地方。有時候力力獅也會害怕,但他會深呼吸、相信自己,然後繼續往前走。",
    bioJa: "リアムはクイービランドのやさしくて勇かんな小さな王子さま。ぼうけんが大すきで、ともだちをあたらしい場所へつれていくよ。リアムもときどきこわくなるけど、深く息をして、自分を信じて、前に進むんだ。",
    image: "/images/characters/c01-liam.png",
    menuIcon: "/images/characters/menu-liam.png",
    overviewImage: "/images/characters/overview-liam.png",
  },
  {
    slug: "fabio-fox",
    name: "Fabio",
    nameZh: "法法狐",
    nameJa: "ファビオ",
    fullName: "Fabio the Fascinating Fox",
    fullNameZh: "法法狐 Fabio",
    fullNameJa: "ふしぎなキツネ ファビオ",
    gender: "Male",
    genderZh: "男生",
    genderJa: "男の子",
    birthday: "June 15th",
    birthdayZh: "6 月 15 日",
    birthdayJa: "6月15日",
    zodiac: "Gemini",
    zodiacZh: "雙子座",
    zodiacJa: "ふたご座",
    bloodType: "Type AB",
    bloodTypeZh: "AB 型",
    bloodTypeJa: "AB型",
    personality: "Full of curiosity and creativity, but sometimes lacks focus and patience.",
    personalityZh: "充滿好奇心與創造力,但有時不夠專注、缺少耐心。",
    personalityJa: "こうきしんとそうぞう力でいっぱい。でも、ちょっとあきっぽいところもあるんだ。",
    interests: "Watching the sparkly stars at night, trying out science experiments, and searching for treasures in the woods.",
    interestsZh: "夜晚看閃亮的星星、做小小科學實驗、在森林裡尋寶。",
    interestsJa: "夜にきらきらの星を見たり、かがくじっけんをしたり、森でたからさがしをすること。",
    favoriteThings: "Stars and the night sky, mysterious experiments, eating strawberries, and exploring with friends.",
    favoriteThingsZh: "星星和夜空、神秘的實驗、草莓,以及和朋友一起探險。",
    favoriteThingsJa: "星と夜空、ふしぎなじっけん、いちご、ともだちとのたんけん。",
    bio: "Fabio is a curious little fox who thinks the world is full of wonder! Sometimes his mind jumps from one thing to another, but that just helps him find amazing surprises. He is learning that even when it's hard to stay still, there is always something cool to discover.",
    bioZh: "法法狐是隻充滿好奇心的小狐狸,覺得世界處處都是驚喜!有時候他的注意力會跳來跳去,但這也讓他發現超棒的驚喜。他正在學:就算很難靜下來,也總會有有趣的東西可以發現。",
    bioJa: "ファビオはこうきしんいっぱいの小さなキツネ。世界はおどろきでいっぱいだとおもっているよ!ときどき気もちがあちこちにとぶけれど、そのおかげですてきなはっけんもできるんだ。じっとするのがむずかしくても、おもしろいものはきっとあるってまなんでいるよ。",
    image: "/images/characters/c02-fabio.png",
    menuIcon: "/images/characters/menu-fabio.png",
    overviewImage: "/images/characters/overview-fabio.png",
  },
  {
    slug: "kaleb-koala",
    name: "Kaleb",
    nameZh: "卡卡熊",
    nameJa: "カレブ",
    fullName: "Kaleb the Kind Koala",
    fullNameZh: "卡卡熊 Kaleb",
    fullNameJa: "やさしいコアラ カレブ",
    gender: "Male",
    genderZh: "男生",
    genderJa: "男の子",
    birthday: "March 21st",
    birthdayZh: "3 月 21 日",
    birthdayJa: "3月21日",
    zodiac: "Aries",
    zodiacZh: "牡羊座",
    zodiacJa: "おひつじ座",
    bloodType: "Type A",
    bloodTypeZh: "A 型",
    bloodTypeJa: "A型",
    personality: "Sweet and friendly, sometimes needs reassurance but is learning his own strength.",
    personalityZh: "甜美友善,有時需要被安慰,但他正在學會發現自己的力量。",
    personalityJa: "やさしくてフレンドリー。ときどき安心がほしくなるけど、自分の力にきづきはじめているよ。",
    interests: "Cozy naps in his favorite tree, math games, and solving the trickiest puzzles.",
    interestsZh: "在最喜歡的樹上小睡、玩數學遊戲、解最難的謎題。",
    interestsJa: "お気に入りの木の上でのんびりおひるね、すうじのあそび、むずかしいパズルをとくこと。",
    favoriteThings: "Eucalyptus-scented things, warm blankets, counting stars, and quiet afternoons.",
    favoriteThingsZh: "尤加利的香氣、溫暖的毛毯、數星星、安靜的午後。",
    favoriteThingsJa: "ユーカリのかおり、あたたかいもうふ、星をかぞえること、しずかな午後。",
    bio: "Kaleb is a sweet and friendly koala who loves cozy naps in his favorite tree. He is a big fan of math games and can solve even the trickiest puzzles! Sometimes Kaleb asks his friends for a little help, and that's okay. He is also learning that he is strong and smart enough to do big things all on his own.",
    bioZh: "卡卡熊是隻甜美友善的小無尾熊,最喜歡在他最愛的樹上小睡。他超喜歡玩數學遊戲,連最難的謎題也難不倒他!有時候卡卡熊會請朋友幫一點忙,那也完全沒關係。他正在學:其實他也夠堅強、夠聰明,可以自己完成大事。",
    bioJa: "カレブはやさしくてフレンドリーなコアラ。お気に入りの木の上でのんびりおひるねするのが大すき。すうじのあそびが大すきで、むずかしいパズルもとけちゃうよ!ときどきともだちにちょっと手つだってもらうこともあるけれど、それでだいじょうぶ。一人でも大きなことができるくらい、自分はつよくてかしこいんだってまなんでいるよ。",
    image: "/images/characters/c03-kaleb.png",
    menuIcon: "/images/characters/menu-kaleb.png",
    overviewImage: "/images/characters/c03-kaleb.png",
  },
  {
    slug: "clyde-crocodile",
    name: "Clyde",
    nameZh: "可可鱷",
    nameJa: "クライド",
    fullName: "Clyde the Calm Crocodile",
    fullNameZh: "可可鱷 Clyde",
    fullNameJa: "おだやかなワニ クライド",
    gender: "Male",
    genderZh: "男生",
    genderJa: "男の子",
    birthday: "January 5th",
    birthdayZh: "1 月 5 日",
    birthdayJa: "1月5日",
    zodiac: "Capricorn",
    zodiacZh: "魔羯座",
    zodiacJa: "やぎ座",
    bloodType: "Type B",
    bloodTypeZh: "B 型",
    bloodTypeJa: "B型",
    personality: "Peaceful and patient, sometimes waits so long he misses a turn, but always stays calm.",
    personalityZh: "平和又有耐心,有時等太久反而錯過機會,但他總是保持冷靜。",
    personalityJa: "おだやかでがまんづよい。まちすぎてチャンスをのがすこともあるけれど、いつもおちついているよ。",
    interests: "Swimming and playing in the cool water, watching clouds drift by, and collecting smooth river stones.",
    interestsZh: "在涼涼的水裡游泳玩耍、看雲飄過、撿光滑的小河石。",
    interestsJa: "つめたい水の中でおよいだりあそんだり、ながれる雲を見たり、つるつるした川の石をあつめたりすること。",
    favoriteThings: "Cool water, lazy afternoons, the sound of rain, and sharing snacks with friends.",
    favoriteThingsZh: "涼涼的水、悠閒的午後、下雨的聲音、和朋友一起分享點心。",
    favoriteThingsJa: "つめたい水、のんびりした午後、雨の音、ともだちとおやつをわけあうこと。",
    bio: "Clyde is a peaceful and patient crocodile who loves to swim and play in the cool water. Sometimes he waits so long that he misses a turn, but he doesn't mind. He knows how to stay quiet and calm while he waits for just the right moment to have his next big adventure.",
    bioZh: "可可鱷是隻平和又有耐心的小鱷魚,最喜歡在涼涼的水裡游泳玩耍。有時候他等太久,會錯過輪到他的機會,但他不在意。他懂得安靜、冷靜地等待,等待下一場大冒險最剛好的時刻。",
    bioJa: "クライドはおだやかでがまんづよいワニ。つめたい水の中でおよいだりあそんだりするのが大すき。じっとまっていてじゅんばんをのがすこともあるけれど、気にしないんだ。つぎのぼうけんにぴったりのしゅんかんを、しずかにおちついてまてるんだよ。",
    image: "/images/characters/c04-clyde.png",
    menuIcon: "/images/characters/menu-clyde.png",
    overviewImage: "/images/characters/c04-clyde.png",
  },
  {
    slug: "dana-deer",
    name: "Dana",
    nameZh: "丹丹鹿",
    nameJa: "ダナ",
    fullName: "Dana the Delightful Deer",
    fullNameZh: "丹丹鹿 Dana",
    fullNameJa: "うれしいシカ ダナ",
    gender: "Female",
    genderZh: "女生",
    genderJa: "女の子",
    birthday: "September 12th",
    birthdayZh: "9 月 12 日",
    birthdayJa: "9月12日",
    zodiac: "Virgo",
    zodiacZh: "處女座",
    zodiacJa: "おとめ座",
    bloodType: "Type A",
    bloodTypeZh: "A 型",
    bloodTypeJa: "A型",
    personality: "Caring and empathetic, sometimes forgets to take care of herself while helping others.",
    personalityZh: "貼心又有同理心,有時太忙著照顧別人,反而忘了照顧自己。",
    personalityJa: "おもいやりがあって、人の気もちがよくわかる。ときどき人をたすけるのにいそがしくて、自分のことをわすれちゃうんだ。",
    interests: "Helping friends in need, arranging wildflowers, and reading stories under the big oak tree.",
    interestsZh: "幫助需要的朋友、把野花排得漂漂亮亮、在大橡樹下讀故事。",
    interestsJa: "こまっているともだちをたすけたり、野の花をきれいにかざったり、大きなオークの木の下でおはなしをよむこと。",
    favoriteThings: "Wildflowers, warm hugs, gentle breezes, and making everyone feel welcome.",
    favoriteThingsZh: "野花、溫暖的擁抱、輕輕的微風,還有讓大家感覺被歡迎的氛圍。",
    favoriteThingsJa: "野の花、あたたかいハグ、やさしい風、みんながかんげいされていると感じるばしょをつくること。",
    bio: "Dana is the most caring deer in all of Queebi Land. She has a huge heart and is the first one to help a friend in need. Sometimes Dana is so busy taking care of others that she forgets to take a little break for herself. She is learning that being kind to herself is just as important as being kind to her friends.",
    bioZh: "丹丹鹿是 酷比島裡最貼心的小鹿。她有一顆大大的心,只要朋友有需要,她一定第一個跳出來幫忙。有時候丹丹鹿太忙著照顧別人,會忘了讓自己休息一下。她正在學:對自己溫柔,跟對朋友溫柔一樣重要。",
    bioJa: "ダナはクイービランドでいちばんおもいやりのあるシカ。とても大きな心をもっていて、こまっているともだちがいたら、まっさきにたすけにいくよ。ときどき人のせわでいそがしすぎて、自分のおやすみをわすれちゃうこともあるんだ。自分にやさしくすることも、ともだちにやさしくするのとおなじくらい大切だってまなんでいるよ。",
    image: "/images/characters/c05-dana.png",
    menuIcon: "/images/characters/c05-dana.png",
    overviewImage: "/images/characters/c05-dana.png",
  },
  {
    slug: "casper-crab",
    name: "Casper",
    nameZh: "居居蟹",
    nameJa: "キャスパー",
    fullName: "Casper the Cheerful Crab",
    fullNameZh: "居居蟹 Casper",
    fullNameJa: "げんきなカニ キャスパー",
    gender: "Male",
    genderZh: "男生",
    genderJa: "男の子",
    birthday: "July 2nd",
    birthdayZh: "7 月 2 日",
    birthdayJa: "7月2日",
    zodiac: "Cancer",
    zodiacZh: "巨蟹座",
    zodiacJa: "かに座",
    bloodType: "Type O",
    bloodTypeZh: "O 型",
    bloodTypeJa: "O型",
    personality: "Happy and helpful, sometimes feels shy or wonders if he can do a good job.",
    personalityZh: "開心又樂於助人,但有時會害羞,懷疑自己能不能做好。",
    personalityJa: "あかるくて、人だすけがすき。ときどきはずかしくなったり、うまくできるかなと心配することもあるよ。",
    interests: "Lending a helping claw to his friends, building sandcastles, and collecting seashells.",
    interestsZh: "用大鉗子幫朋友的忙、堆沙堡、收集貝殼。",
    interestsJa: "ともだちをはさみでてつだったり、すなのおしろをつくったり、貝がらをあつめたりすること。",
    favoriteThings: "Ocean waves, colorful seashells, sunny beach days, and making new friends.",
    favoriteThingsZh: "海浪、五顏六色的貝殼、晴朗的海灘日,還有交新朋友。",
    favoriteThingsJa: "海のなみ、カラフルな貝がら、晴れたビーチの日、あたらしいともだちをつくること。",
    bio: "Casper is a happy little crab who loves to lend a helping claw to his friends. Sometimes Casper feels a little bit shy or wonders if he can do a good job. But every day, he is learning to believe in himself and see just how wonderful he truly is.",
    bioZh: "居居蟹是隻開心的小螃蟹,最喜歡用大鉗子幫朋友的忙。有時候他會有點害羞,會懷疑自己做不做得好。但他每天都在練習相信自己,看見自己其實有多棒。",
    bioJa: "キャスパーはあかるい小さなカニ。ともだちをはさみでてつだうのが大すき。ときどきちょっとはずかしくなったり、うまくできるかなとおもうこともあるよ。でも、まいにち自分を信じて、自分がどんなにすてきかをみつけるれんしゅうをしているんだ。",
    image: "/images/characters/c06-casper.png",
    menuIcon: "/images/characters/c06-casper.png",
    overviewImage: "/images/characters/c06-casper.png",
  },
];

export function getCharacterBySlug(slug: string): Character | undefined {
  return characters.find((c) => c.slug === slug);
}

export function getCharacterDisplayName(character: Character, lang: string): string {
  if (lang === "zh") return character.nameZh;
  if (lang === "ja") return character.nameJa;
  return character.name;
}

type LocalizableField =
  | "fullName"
  | "gender"
  | "birthday"
  | "zodiac"
  | "bloodType"
  | "personality"
  | "interests"
  | "favoriteThings"
  | "bio";

export function getCharacterField(
  character: Character,
  field: LocalizableField,
  lang: string
): string {
  if (lang === "zh") {
    const key = `${field}Zh` as keyof Character;
    return (character[key] as string) || (character[field] as string);
  }
  if (lang === "ja") {
    const key = `${field}Ja` as keyof Character;
    return (character[key] as string) || (character[field] as string);
  }
  return character[field] as string;
}
